import { Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { RestService } from 'src/app/services/rest.service';
import { TranslateService } from '@ngx-translate/core';
import Keyboard from "simple-keyboard";
import layout from "simple-keyboard-layouts/build/layouts/spanish";

declare var google: any;

@Component({
  selector: 'cicerone-keyboard-on-screen',
  templateUrl: './keyboard-on-screen.page.html',
  styleUrls: ['./keyboard-on-screen.page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class KeyboardOnScreenComponent {
  @ViewChild('inputKeyboardValue') inputKeyboardValue: ElementRef<HTMLInputElement>;
  @Input("input") input;
  @Input("title") title;
  @Input("google") google;
  keyboard: Keyboard;
  locationPoint: any;
  searchBox: any;
  keyPressAction: string;

  constructor(
    public modalCtrl: ModalController,
    public rest: RestService,  
    public translate: TranslateService) 
  {}

  ngAfterViewInit() {
    this.inputKeyboardValue.nativeElement.focus();
    
    if (this.inputKeyboardValue.nativeElement && this.google){
      this.inputKeyboardValue.nativeElement.placeholder = this.translate.instant(this.title);
        const center = this.rest.device?.location;
        const defaultBounds = { north: center.latitude + 0.5, south: center.latitude - 0.5, east: center.longitude + 0.5, west: center.longitude - 0.5 };
        const options = { bounds: defaultBounds, strictBounds: true, types: [], componentRestrictions: {country: 'es' } };
        this.searchBox = new google.maps.places.Autocomplete(this.inputKeyboardValue.nativeElement, options);                  
        this.searchBox.addListener('place_changed', () => {
            const place = this.searchBox.getPlace();
            const latitudeForm = place.geometry.location?.lat();
            const longitudeForm = place.geometry.location?.lng();
            this.locationPoint = { 'latitude': latitudeForm, 'longitude': longitudeForm, 'name': place.name };
        });
    }

    this.keyboard = new Keyboard({
      inputName: "default",
      display: { 
        '{bksp}': this.translate.instant('Borrar'), 
        '{enter}': this.translate.instant('Intro'), 
        '{tab}': this.translate.instant('Tab'), 
        '{lock}': this.translate.instant('Blq. Mayus'),
        '{shift}': this.translate.instant('Mayus'), 
        '{space}': this.translate.instant('Espacio')
      },
      onChange: input => { this.onChange(input); },
      onKeyPress: button => { this.onKeyPress(button) },
      ...layout
    });
    this.focusInput();
  }

  onChange = (input: string) => {
    if (this.keyPressAction == 'shift'){
      this.keyboard.setOptions({ layoutName: 'default' });
    }

    const inputEl = this.inputKeyboardValue.nativeElement;
    inputEl.focus();
    let startPos = inputEl.selectionStart || 0;
    let oldLength = inputEl.value.length;
    inputEl.value = input;
    let newLength = input.length;
    let diff = newLength - oldLength;
    let newCursorPos = startPos + diff;
  
    if (newCursorPos < 0) newCursorPos = 0;
    if (newCursorPos > newLength) newCursorPos = newLength;
  
    inputEl.setSelectionRange(newCursorPos, newCursorPos);
    setTimeout(() => { inputEl.focus() }, 200);
  };

  onKeyPress = (button: string) => {
    if (button === "{shift}"){
      this.keyPressAction = 'shift';
      this.handleShift();
    }

    if (button === "{lock}"){
      this.keyPressAction = 'lock';
      this.handleShift();
    }
  };

  handleShift = () => {
    let currentLayout = this.keyboard.options.layoutName;
    let shiftToggle = currentLayout === "default" ? "shift" : "default";
    this.keyboard.setOptions({ layoutName: shiftToggle });
  };

  updateCursor(input) {
    this.keyboard.setInput(input)
  }

  focusInput(){
      this.keyboard.setInput(this.inputKeyboardValue.nativeElement.value, "default");
    }

  clearKeyBoard(){
    this.inputKeyboardValue.nativeElement.value = '';
    this.focusInput();
  }

  sendData(){
      const inputValue = this.inputKeyboardValue.nativeElement.value;
      this.modalCtrl.dismiss(
        this.google 
          ? {'location': this.locationPoint, 'data': inputValue} 
          : {'data': inputValue}
      );
  }

  dismissModal(){
    this.modalCtrl.dismiss();
  }

}